import React from 'react';
import { ChevronRight } from 'lucide-react';
import { motion } from 'framer-motion';

const ProcessSection = () => {
  return (
    <section className="bg-slate-50 py-20 lg:py-24">
      <div className="container px-4 mx-auto">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12 lg:mb-16">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
              Notre processus de <span className="text-orcsys-500">développement</span>
            </h2>
            <p className="text-lg text-slate-600 max-w-3xl mx-auto">
              Un parcours clair et transparent, du concept au lancement réussi 
              de votre application mobile.
            </p>
          </div>

          <div className="relative">
            {/* Process steps - Fixed horizontal line positioning */}
            <div className="hidden md:block absolute h-1 bg-slate-200 top-[45px] left-[15%] right-[15%]" />
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
              {[
                {
                  icon: <div className="w-6 h-6 flex items-center justify-center rounded-full bg-orcsys-500 text-white">1</div>,
                  title: "Conception & Planification",
                  description: "Nous définissons ensemble les objectifs, les fonctionnalités et la feuille de route de votre application."
                },
                {
                  icon: <div className="w-6 h-6 flex items-center justify-center rounded-full bg-orcsys-500 text-white">2</div>,
                  title: "Design & Développement",
                  description: "Nos designers et développeurs créent une interface intuitive et un code robuste pour votre application."
                },
                {
                  icon: <div className="w-6 h-6 flex items-center justify-center rounded-full bg-orcsys-500 text-white">3</div>,
                  title: "Tests & Lancement",
                  description: "Nous testons rigoureusement l'application, puis la déployons sur les stores avec un plan de communication."
                }
              ].map((step, index) => (
                <motion.div
                  key={index}
                  className="relative"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: index * 0.2 }}
                  viewport={{ once: true }}
                >
                  {/* Step indicator - Fixed positioning */}
                  <div className="absolute top-0 left-1/2 -translate-x-1/2 md:-translate-y-1/2 z-10">
                    <div className="flex items-center justify-center w-20 h-20 md:w-24 md:h-24 bg-white rounded-full border-8 border-slate-50 shadow-lg">
                      <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-orcsys-500 flex items-center justify-center text-white font-bold text-xl">
                        {step.icon}
                      </div>
                    </div>
                  </div>
                  
                  {/* Content - Improved spacing */}
                  <div className="bg-white rounded-xl p-6 pt-14 md:pt-16 mt-10 md:mt-12 shadow-lg h-full border border-slate-100 hover:border-orcsys-100 transition-all duration-300 hover:shadow-xl text-center">
                    <h3 className="text-xl font-bold text-slate-900 mb-3">{step.title}</h3>
                    <p className="text-slate-600">{step.description}</p>
                    
                    
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection; 